<template>
  <v-container class="custom-container custom-responsive-height">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search Manager ..."
                single-line
                solo
                hide-details
                class="custom-v-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-3 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable"
                  :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    :search="search"
                    :items-per-page="5"
                  >
                    <template v-slot:item.assign="{ item }">
                      <v-btn
                        elevation="0"
                        small
                        :class="assignActive(item.assign)"
                        >{{ item.assign }}</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Account Name", value: "accountName" },
        { text: "Manager ID", value: "managerId" },
        { text: "Clients", value: "clientsNo" },
        { text: "Assign", value: "assign" },
      ],
      desserts: [
        {
          sl: "1",
          accountName: "Umor Bin Khattab",
          managerId: "213293736",
          clientsNo: 1092,
          assign: "Assigned",
        },
        {
          sl: "2",
          accountName: "Abu Bokor Siddik",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assign",
        },
        {
          sl: "3",
          accountName: "Hamza (r)",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assign",
        },
        {
          sl: "4",
          accountName: "Usman (r)",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assigned",
        },
        {
          sl: "5",
          accountName: "Ali (r)",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assign",
        },
        {
          sl: "6",
          accountName: "Khalid bin Walid",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assign",
        },
        {
          sl: "7",
          accountName: "Talha(r)",
          managerId: "4698372",
          clientsNo: 1733,
          assign: "Assign",
        },
      ],
    };
  },
  methods: {
    assignActive(status) {
      if (status === "Assigned") return "btn-assign btn-assign-approved";
      else return "btn-assign";
    },
  },
};
</script>
